import styled, { css } from "styled-components";
import photo from "assets/images/Suyane_Mike_HickDuarte_34389.jpg";
import photoMobile from "assets/images/Suyane_Mike_HickDuarte_34448.jpg";
import { fonts } from "styles";
import { motion } from "framer-motion";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  position: relative;
`;

export const Content = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  height: 100vh;
  padding: 124px;
  position: relative;
  z-index: 2;

  @media screen and (max-width: 1023px) {
    align-items: flex-start;
    padding: 48px 124px;
  }

  @media screen and (max-width: 768px) {
    padding: 48px 72px;
  }

  @media screen and (max-width: 414px) {
    padding: 48px;
  }
`;

export const Background = styled(motion.div)`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: url(${photo}) no-repeat center center;
  background-size: cover;
  z-index: 1;

  @media screen and (max-width: 768px) {
    background: url(${photoMobile}) no-repeat center center;
    background-size: cover;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h1`
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 88px;
  line-height: 88px;
  letter-spacing: -2px;
  color: white;
  text-transform: uppercase;
  margin-bottom: 32px;

  @media screen and (max-width: 1023px) {
    font-size: 72px;
    line-height: 72px;
  }

  @media screen and (max-width: 768px) {
    font-size: 54px;
    line-height: 54px;
  }

  @media screen and (max-width: 500px) {
    font-size: 44px;
    line-height: 44px;
  }

  @media screen and (max-width: 375px) {
    font-size: 32px;
    line-height: 32px;
  }

  @media screen and (max-width: 320px) {
    font-size: 28px;
    line-height: 28px;
  }
`;

export const Text = styled.article`
  width: 100%;
  max-width: 480px;
  font-size: 16px;
  line-height: 24px;
  color: white;

  p {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    span {
      font-family: ${fonts.BentonSansBold};
    }
  }

  @media screen and (max-width: 1023px) {
    p:last-child {
      display: none;
    }
  }

  @media screen and (max-width: 500px) {
    font-size: 14px;
    line-height: 20px;
  }

  @media screen and (max-width: 320px) {
    font-size: 12px;
    line-height: 18px;
  }
`;

export const Credit = styled.article`
  width: 100%;
  max-width: 270px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  line-height: 20px;
  position: absolute;
  right: 72px;
  bottom: 124px;

  p {
    display: none;
    font-size: 16px;
    margin-bottom: 16px;
    span {
      font-family: ${fonts.BentonSansBold};
    }
  }

  @media screen and (max-width: 1023px) {
    right: auto;
    left: 124px;
    bottom: 72px;

    p {
      display: block;
    }
  }

  @media screen and (max-width: 768px) {
    left: 72px;
  }

  @media screen and (max-width: 500px) {
    p {
      font-size: 14px;
      line-height: 16px;
    }
    font-size: 10px;
    line-height: 16px;
  }

  @media screen and (max-width: 414px) {
    left: 48px;
  }

  @media screen and (max-width: 320px) {
    max-width: 220px;
    bottom: 72px;
  }
`;
